// Точка отправки событий без зависимостей: экраны и модули данных шлют сюда, не зная про gtag, Telegram и окно.
// Приёмник ставит analytics.ts при запуске. До того события копятся в очереди и уходят при установке приёмника — так
// не теряется первый экран холодного старта (маршрутизатор создаётся при импорте App, раньше initAnalytics). Аналитика
// выключена (dev, тесты без приёмника) — setSink(null): очередь сбрасывается, дальше события молча пропадают.
export type Params = Record<string, string | number | boolean | undefined>;
type Sink = (name: string, params: Params) => void;
type Event = [name: string, params: Params];
/** Предел очереди до запуска: защита от утечки, если приёмник так и не поставят. */
const QUEUE_LIMIT = 100;
let sink: Sink | null = null;
let queue: Event[] | null = [];
/** Последний показанный экран (screen_name последнего screen_view) — экран для событий вне оболочки (js_error). */
let screen: string | undefined;
export const lastScreen = (): string | undefined => screen;

/** Ставит приёмник: сначала уходят lead (tg_launch — первым событием сессии), потом накопленное до запуска.
 *  null — аналитики не будет: очередь сбрасывается. */
export function setSink(fn: Sink | null, lead: Event[] = []): void {
  sink = fn;
  const pending = queue ?? [];
  queue = null;
  if (fn) for (const [name, params] of [...lead, ...pending]) send(name, params);
}
function send(name: string, params: Params): void {
  try { sink?.(name, params); } catch { /* аналитика не роняет приложение */ }
}
export function track(name: string, params: Params = {}): void {
  if (name === 'screen_view' && typeof params.screen_name === 'string') screen = params.screen_name;
  if (queue) { if (queue.length < QUEUE_LIMIT) queue.push([name, params]); return; }
  send(name, params);
}

// ---- Обезличенный номер пользователя (analytics_id бэкенда: HMAC внутреннего id, не Telegram id) — склейка событий
// Google с данными сервера и одного человека на разных устройствах. Приходит в ответах входа; помним между запусками.
const USER_KEY = 'football.analytics_id';
let userSink: ((id: string) => void) | null = null;
export function setUserSink(fn: typeof userSink): void { userSink = fn; }
export function savedAnalyticsUser(): string | null {
  try { return localStorage.getItem(USER_KEY); } catch { return null; }
}
export function rememberAnalyticsUser(id: unknown): void {
  if (typeof id !== 'string' || !/^[A-Za-z0-9_-]{8,64}$/.test(id)) return;
  try { localStorage.setItem(USER_KEY, id); } catch { /* приватный режим */ }
  try { userSink?.(id); } catch { /* аналитика не роняет вход */ }
}
